import {OpzioniItem} from "../gestversore/types";


export const DittaList: OpzioniItem[] = [
  { id: "1",  label: "IN4IT" },
  { id: "2",  label: "BS" },
];


export type ReportClientiVersore = {
  nrrel?: number;
  ditta?: number;
  datareg?: Date | null;
  variante?: string;
  opzione?: string;
  coddip?: string;
  oreord?: number;
  minord?: number;
  codprog?: string;
  note?: string;
  codatt?: string;
  codnodo?: string;
  datains?: Date | null;
  desnodo?: string;
  desatt?: string;
  codagente?: string;
  codcli?: number;
  nomeagente?: string;
  ref?: string;
  flgval?: string;
  ore?: number;
  ragsoccli?: string;
  desditta?: string;
  desprog?: string;
  nomedip?: string;

};

export type  ReportClientiVersoreApiResponse = {
  results: Array<ReportClientiVersore>;
  count: number;
};


export function mapJsonToReportClientiVersoreApiResponse(jsonData: any): ReportClientiVersoreApiResponse {
  const mappedData: ReportClientiVersoreApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
    nrrel: item.VBT51_NRREL,
    ditta: item.VBT59_DITTA,
    datareg: item.VBT51_DATAREG,
    variante: item.VBT51_VARIANTE,
    opzione: item.VBT51_OPZIONE,
    coddip: item.VBT51_CODDIP,
    oreord: item.VBT51_OREORD,
    minord: item.VBT51_MINORD,
    codprog: item.VBT51_CODPROG,
    note: item.VBT51_NOTE,
    codatt: item.VBT51_CODATT,
    codnodo: item.VBT51_CODNODO,
    datains: item.VBT51_DATAINS,
    desnodo: item.VBT51_DESNODO,
    desatt: item.VBT51_DESATT,
    codagente: item.VBT51_CODAGENTE,
    codcli: item.VBT51_CODCLI,
    nomeagente: item.VBT51_NOMEAGENTE,
    ref: item.VBT51_REF,
    flgval: item.VBT51_FLGVAL,
    ore: item.VBT51_ORE,
    ragsoccli: item.VBT51_RAGSOCCLI,
    desditta: item.VBT51_DESDITTA,
    desprog: item.VBT51_DESPROG,
    nomedip: item.VBT51_NOMEDIP,
    })),
  };

  return mappedData;
}


export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };




